var _rect, _path, _path2, _path3, _rect2, _rect3, _rect4, _rect5, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgHighEndSafe = function SvgHighEndSafe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 4,
    fill: "#FFF9DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFE9",
    stroke: "#332C4A",
    strokeWidth: 1.667,
    d: "M70 80v5H60v-5zM40 80v5H30v-5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.667 81.667V18.333H23.333v63.334h53.334z",
    fill: "#DFDFE9",
    stroke: "#332C4A",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.667 75V25H28.333v50h43.334z",
    fill: "#F8F8FB",
    stroke: "#332C4A",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 45.833,
    y: 45.833,
    width: 8.333,
    height: 8.333,
    rx: 4.167,
    fill: "#FFD400",
    stroke: "#332C4A",
    strokeWidth: 1.667
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 48.333,
    y: 48.333,
    width: 3.333,
    height: 3.333,
    rx: 1.667,
    fill: "#332C4A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 33.333,
    y: 47.5,
    width: 5,
    height: 12.5,
    rx: 2.5,
    fill: "#FFD400",
    stroke: "#332C4A",
    strokeWidth: 1.667
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 33.333,
    y: 47.5,
    width: 5,
    height: 5,
    rx: 2.5,
    fill: "#FFD400",
    stroke: "#332C4A",
    strokeWidth: 1.667
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8FB",
    stroke: "#332C4A",
    strokeWidth: 1.667,
    d: "M71.667 30h5v10h-5zM71.667 60h5v10h-5z"
  })));
};

export default SvgHighEndSafe;